/*
 * @Author: your name
 * @Date: 2022-03-30 17:40:42
 * @LastEditTime: 2022-04-02 15:43:55
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \mingyao\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path:"/power",
    name:"power",
    component:()=> import('../views/Power.vue')
  },
  {
    path:"/news",
    name:"news",
    component:()=> import('../views/News.vue')
  },
  {
    path:"/service",
    name:"service",
    component:()=> import('../views/Service.vue')
  },
  {
    path:"/case",
    name:"Case",
    component:()=> import('../views/Case.vue')
  },
  {
    path:"/contact",
    name:"Contact",
    component:()=> import('../views/Contact.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
